import { getApiInfo } from '@/assets/api.js';
import qs from 'qs';
const wxUrl = '/index.php';
//微信小程序
const getwxSign2 = (params) => {
  const url = `https://article.ijiangyin.com:90/index.php/portal/news/getWeixinSignatureZjyapp`;
  return getApiInfo(url, params);
}
export { getwxSign2 }



// WEBPACK FOOTER //
// ./src/assets/homeapi.js